(ns frontend.view.modals.account-disable.events
  (:require
   [frontend.actions.account :as account-actions]
   [frontend.view.modals.components.processing-modal :as processing-modal]))

(defn update!
  [state k val]
  (swap! state assoc-in [:edit k] val))

(defn disable-account!
  [account role state on-submit!]
  (processing-modal/start-processing! state)

  (let [{:keys [oppo-owner person-owner company-owner fund-commitment-owner
                holding-owner webentry-owner kpi-report-owner fundraising-opportunity-owner
                sales-opportunity-owner sale-agreement-owner
                exit-opportunity-owner
                contact-list-handling-strategy contact-list-replacement-account]} (:edit @state)
        msg (merge
             {:account-id (:db/id account)
              :role-id    (:db/id role)}
             (when oppo-owner
               {:oppo-owner-id oppo-owner})
             (when person-owner
               {:person-owner-id person-owner})
             (when company-owner
               {:company-owner-id company-owner})
             (when fund-commitment-owner
               {:fund-commitment-owner-id fund-commitment-owner})
             (when holding-owner
               {:holding-owner-id holding-owner})
             (when kpi-report-owner
               {:kpi-owner-id kpi-report-owner})
             (when webentry-owner
               {:webentry-owner-id webentry-owner})
             (when fundraising-opportunity-owner
               {:fundraising-opportunity-owner-id fundraising-opportunity-owner})
             (when sales-opportunity-owner
               {:sales-opportunity-owner-id sales-opportunity-owner})
             (when sale-agreement-owner
               {:sale-agreement-owner-id sale-agreement-owner})
             (when exit-opportunity-owner
               {:exit-opportunity-owner-id exit-opportunity-owner})
             (when contact-list-handling-strategy
               {:contact-list-handling-strategy contact-list-handling-strategy})
             (when (= contact-list-handling-strategy :replace)
               {:contact-list-replacement-account contact-list-replacement-account}))]
    (account-actions/*->disable
     msg
     (fn [_e]
       (processing-modal/success! state)
       (when on-submit!
         (on-submit!)))
     (fn [response]
       (processing-modal/error! state response)
       (when on-submit!
         (on-submit!))))))
